import { cva, RecipeVariantProps } from "styled-system/css";

export const dateInputRecipe = cva({
  base: {
    background: "white", // Important is required to override the default background color of the button
    border: "none",
    borderRadius: "100",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    outlineWidth: "1px",
    outlineColor: "border.light",
    outlineStyle: "solid",
    boxShadow: "0 0 0 0px var(--wa-colors-border-light)",
    px: "150",
    py: "100",
    width: "full",
    // Match the height of the filled state (22px text line + 8px padding on
    // each side) so the trigger doesn't shrink when no date is selected and
    // only the 16px calendar icon is rendered.
    minHeight: "38px",
    transitionDuration: "normal",
    transitionProperty: "all",
    transitionTimingFunction: "default",
    _hover: {
      background: "white",
      outlineColor: "border.mid",
      boxShadow: "0 0 0 2px var(--wa-colors-border-mid)",
    },
    _focus: {
      background: "white",
      outlineColor: "border.dark",
      boxShadow: "0 0 0 2px var(--wa-colors-border-dark)",
    },
    _focusVisible: {
      background: "white",
      outlineOffset: 0,
      outlineColor: "border.dark",
      boxShadow: "0 0 0 2px var(--wa-colors-border-dark)",
    },
  },
  variants: {
    error: {
      true: {
        background: "white",
        outlineColor: "border.error",
        boxShadow: "0 0 0 2px var(--wa-colors-border-error)",
      },
    },
    empty: {
      true: {
        width: "auto",
        minWidth: "48px",
        justifyContent: "center",
        px: "100",
        py: "100",
      },
    },
  },
  defaultVariants: {
    error: false,
    empty: false,
  },
});

export type DateInputRecipeProps = RecipeVariantProps<typeof dateInputRecipe>;
